// extracted by mini-css-extract-plugin
export default {"root":"ChartPeriodControl_root__80IGe","buttonContainer":"ChartPeriodControl_buttonContainer__3kRaz","active":"ChartPeriodControl_active__zrVQ-"};